import { Button } from '@mui/material';
import React from 'react';
import { fileDownloaderWithName } from '../../../utils/fileDownloader';
import { DownloadRounded } from '@mui/icons-material';
import { base_api_url } from '../../../services/httpService';
import Alert from '../../../utils/Alert';
import axios from 'axios';

const ReceiptTransaction = ({ rowData }) => {
    const downloadReceiptImage = (fileURL, fileName) => {
        const token = JSON.parse(localStorage.getItem("cncToken"));  

        axios.get(fileURL, {  
            headers: {  
                "Authorization": token ? `Bearer ${token.access}` : null  
            },  
            responseType: 'blob'
        })  
        .then(response => {  
            if (response.status === 200) {  
                const blob = new Blob([response.data]);
                const downloadLink = document.createElement("a");  
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = fileName; 
                downloadLink.style.display = "none";  
                document.body.appendChild(downloadLink);  
                downloadLink.click(); 
                document.body.removeChild(downloadLink);
            } else if (response.status === 204) {  
                Alert(`خطا ${response.status}!`, "فایل مورد نظر وجود ندارد!", "error");  
            }  
        })  
        .catch(error => {  
            Alert(`خطا ${error.response?.status || ""}!`, `در دانلود فایل مشکلی رخ داده است:\n${error.message}`, "error");  
        });  
    };  

    return (
        <span>  
            {!rowData.receipt ? (  
                <>
                    ندارد
                </>
            ) : (  
                <Button
                    variant="contained"
                    onClick={() => 
                        {
                            downloadReceiptImage(`${base_api_url}/shop_admin/get_receipt_file/${rowData.id}/`, 'receipt.jpg');
                        }}
                >
                    دانلود
                    <span className="ms-1">
                        <DownloadRounded />
                    </span>
                </Button>
            )}  
        </span>  
    );
}

export default ReceiptTransaction;